import React from 'react'
import { useTranslation } from 'react-i18next'

const RightPriceDetailsTabs = () => {
    const { t } = useTranslation();

  return (
     <div className="card-box">
        <div className="top-card-box border-0 p-25">
        <ul className="d-flex justify-content-between gap-2 m-0 p-0 list-unstyled">
            <li> {t("adult")} </li>
            <li> {t("priceTotal")} </li>
        </ul>
        <ul className="d-flex justify-content-between gap-2 m-0 p-0 list-unstyled">
            <li> {t("cabin")} </li>
            <li> {t("included")} </li>
        </ul>
        <ul className="d-flex justify-content-between gap-2 m-0 p-0 list-unstyled">
            <li> {t("checked")} </li>
            <li> {t("included")} </li>
        </ul>
        <ul className="d-flex justify-content-between gap-2 m-0 p-0 list-unstyled">
            <li> {t("saver")} </li>
            <li> {t("saver")} </li>
        </ul>
        </div>
        <div className="bottom-box-card p-25 pt-0">
        <ul className="pt-0 pb-4 total-price-box d-flex justify-content-between gap-2 m-0 p-0 list-unstyled">
            <li>{t("totalText")} <span> {t("INR")} </span></li>
            <li>₹ 10,132.13</li>
        </ul>
        <span> 
            {t("note")}
        </span>
        </div>
    </div>
  )
}

export default RightPriceDetailsTabs